import { Injectable } from '@angular/core';
import { LoginConfigService } from 'gung-standard';
import { CarLinerLoginComponent } from '../components/car-liner-login/car-liner-login.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerLoginConfigService extends LoginConfigService {
  getLoginComponent(loginType?: any) {
    if (loginType === 'FashionLogin') {
      return CarLinerLoginComponent;
    }
    return super.getLoginComponent(loginType);
  }
}
